import React, { useState } from "react";
import PropTypes from "prop-types";
import style from "./burger-menu.css";
import SwipeableViews from "react-swipeable-views";
import SVGIcon from "../common/svg-icon";
import analytics from "analytics/analytics";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

function BurgerMenu(props) {
    const [menuHidden, setMenuHidden] = useState(true);
    const [selectedGender, setSelectedGender] = useState(props.userGender ? props.userGender : "Women");
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [genderMenuIndex, setGenderMenuIndex] = useState(getGenderIndex());
    const [mainMenuIndex, setMainMenuIndex] = useState(0);
    const burgerHolderRef = React.createRef();

    function getGenderIndex() {
        return selectedGender === "Men" ? 1 : 0;
    }

    function renderGenderSelector() {
        if (selectedGender) {
            return (
                <div className={style.genderSelector}>
                    <div className={selectedGender === "Women" ? style.genderActive : style.genderOption} onClick={
                        () => onGenderClick("Women")
                    }>Women</div>
                    <div className={selectedGender === "Men" ? style.genderActive : style.genderOption} onClick={
                        () => onGenderClick("Men")
                    }>Men</div>
                </div>
            );
        }
    }

    function renderGenderMenus() {
        let genderMenus = props.data.map((genderedMenu, index) => {
            return (
                <ul key={index} id="genderedMenuLinks">
                    {
                        genderedMenu.by_category.categories.map((category, index) => {
                            return (
                                <li key={index} className={style.menuItem} onClick={
                                    () => onCategoryClick(category.name)
                                }>
                                    {renderMenuItemContent(category.name)}
                                </li>
                            );
                        })
                    }
                    {
                        genderedMenu.by_brand.categories.map((brand, index) => {
                            return (
                                <li key={index} className={style.menuItem}>
                                    <a key={index} href={brand.single_link}>
                                        {renderMenuItemContent(brand.name)}
                                    </a>
                                </li>
                            );
                        })
                    }
                    <li className={style.smallMenuItem}>GB-£GBP</li>
                    <li><a className={style.smallMenuItem} href="https://help.lyst.com/hc/en-gb">Help center</a></li>
                    <li><a className={style.smallMenuItem} href="/help/contact-us/">Contact us</a></li>
                    <li><a className={style.smallMenuItem} href="/about/">About us</a></li>
                    <li><a className={style.smallMenuItem} href="/careers/">Careers</a></li>
                </ul>
            );
        });
        return (
            <div className={style.genderedMenu}>
                {renderGenderSelector()}
                <SwipeableViews disabled index={genderMenuIndex}>
                    {genderMenus}
                </SwipeableViews>
            </div>
        );

    }

    function renderCategoryMenu() {
        if (selectedGender && selectedCategory) {
            var genderedMenu = props.data.filter(obj => {
                return obj.gender === selectedGender.toLowerCase();
            })[0];
            var categoryMenu = genderedMenu.by_category.categories.filter(category => {
                return category.name === selectedCategory;
            })[0];
            return (
                <div>
                    <div className={style.categoryMenuHeader}>
                        <div className={style.menuItemBigChevron} onClick={onBackToMainClick}>
                            <SVGIcon name="chevron" flip/>
                        </div>
                        <div className={style.categoryTitle}>{selectedCategory}</div>
                    </div>
                    <ul id="categoryMenuLinks">
                        {
                            categoryMenu.links.map((link, index) => {
                                return (
                                    <li key={index} className={style.menuItem}>
                                        <a key={index} href={link.url}>
                                            <div className={style.menuItemContent}>
                                                <p>{link.text}</p>
                                            </div>
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    }


    function renderMenuItemContent(value) {
        return (
            <div className={style.menuItemContent}>
                <p>{value}</p>
                <div className={style.menuItemChevron}><SVGIcon name="chevron"/></div>
            </div>
        );
    }

    function onBurgerClick() {
        analytics.event(
            "nav",
            `${!menuHidden ? "closed" : "opened"}`,
            `nav_${selectedGender.toLowerCase()}_menu`
        );

        document.body.classList.toggle("no-scroll", menuHidden);
        if (menuHidden) {
            disableBodyScroll(burgerHolderRef.current);
        } else {
            clearAllBodyScrollLocks();
        }

        scrollToTop();
        setMenuHidden(!menuHidden);
        setSelectedCategory(null);
        setMainMenuIndex(0);
    }

    function onGenderClick(gender) {
        if (gender === "Men") {
            setGenderMenuIndex(1);
        } else {
            setGenderMenuIndex(0);
        }
        setSelectedGender(gender);
        setSelectedCategory(null);
    }

    function onCategoryClick(categoryName) {
        analytics.event("nav", "clicked", `user_click_${categoryName}`);
        scrollToTop();
        setSelectedCategory(categoryName);
        setMainMenuIndex(1);
    }

    function onBackToMainClick() {
        setSelectedCategory(null);
        setMainMenuIndex(0);
    }

    function scrollToTop() {
        if (burgerHolderRef.current) {
            burgerHolderRef.current.scrollTo(0, 0);
        }
    }

    return (
        <div className={style.burgerHolder}>
            <div className={menuHidden ? style.burgerContainer : style.burgerCross} onClick={
                () => onBurgerClick()
            }>
                <div className={style.burgerBar1}></div>
                <div className={style.burgerBar2}></div>
                <div className={style.burgerBar3}></div>
            </div>
            <div
                ref={burgerHolderRef}
                className={menuHidden ? style.menuCollapsed : style.menuExpanded}
            >
                <SwipeableViews disabled index={mainMenuIndex}>
                    {renderGenderMenus()}
                    {renderCategoryMenu()}
                </SwipeableViews>
            </div>
        </div>
    );
}

BurgerMenu.defaultProps = {
    data: [],
    userGender: "",
};

BurgerMenu.propTypes = {
    data: PropTypes.array,
    userGender: PropTypes.string,
};

export default BurgerMenu;
